/* eslint-disable */
export default {
  callerCall: 'Appelant',
  transferCall: 'Transfert',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
